import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import UserContext from '../tools/contextLib'
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import moment from 'moment';

export class GenDormAccess extends Component {
    static displayName = GenDormAccess.name;
    //This page is not in use
    constructor(props) {
        super(props);
        this.state = {
            browser: `${browserName}${browserVersion}`,
            ip: "",
            returnable: [],
            loading: true,
            username: "",
            permissionFlag: true,
        }
        this.getUserInfo();
    }

    componentDidMount() {

    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data,
            loading: false,
            username: data.username
        });
        this.getUserIP();
        //var dept = this.state.returnable.level 
        //dept = dept.substring(0, dept.indexOf('-') - 1); 
    }

    async getUserIP() {
        const response = await axios.get('https://geolocation-db.com/json/');
        this.setState({
            IP: response.data.IPv4
        }, () => {
            this.testPermission();
            this.recordComingHere(); });
    }

    async recordComingHere() { 
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            pagePK: "0",
            department: this.state.returnable.level,
            userPCID: this.state.returnable.pcid,
            ip: this.state.IP,
            browser: this.state.browser,
            userID: this.state.returnable.username
        }
        const response = await fetch('logging', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
    }

    async testPermission() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            pagepk: "0"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    render() {
        if(this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        if (this.props.justSwitch == true) {
            this.props.passNewPage(1);
        }
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <h1>General Dorm Hall Access</h1>
                    )}
                </UserContext.Consumer>
            );    
    }
}